export default __webpack_public_path__ + "783ffa023741bc0ec33d1d57aee0b876.png";